import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MUITooltip from '@material-ui/core/Tooltip';

import { Label } from '../label';
import useStyles from './tag.styles';

export const INTERNAL_TAG_TOOLTIP = 'Only Branch employees see this';

const Tag = ({ children, className, variant, tooltip }) => {
  const classes = useStyles();
  const internal = variant === 'internal';
  const tag = (
    <Label variant="darkGreenSmall" className={classNames(classes.tag, { [classes.internal]: internal }, className)}>
      {children}
    </Label>
  );
  if (!internal) {
    return tag;
  }
  return (
    <MUITooltip title={tooltip ?? INTERNAL_TAG_TOOLTIP}>
      <span className={classes.tooltipAnchor}>{tag}</span>
    </MUITooltip>
  );
};

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  // `internal` marks something the viewer sees only because of their access: a dashed outline, no fill.
  variant: PropTypes.oneOf(['default', 'internal']),
  // Internal tags only; defaults to INTERNAL_TAG_TOOLTIP.
  tooltip: PropTypes.string
};

Tag.defaultProps = {
  className: '',
  variant: 'default',
  tooltip: undefined
};

export default Tag;
